/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// INTERFACES
import { PermissionInterface } from "../../interfaces/Permissions.interface";
import { FormAction } from "../../types/enums";

/**
 * State of the permission slice: the permission currently being viewed or edited,
 * the active selection, and the open/closed flags for this area's modals.
 */
export interface PermissionState {
  permission: PermissionInterface;
  openModalDeletePermission: boolean;
  formAction: FormAction;
}

const initialState: PermissionState = {
  permission: {
    id: "",
    name: "",
    method: "GET",
    uri: "",
    group: "",
    parent: "",
  },
  openModalDeletePermission: false,
  formAction: FormAction.Create,
};

export const permissionSlice = createSlice({
  name: "permission",
  initialState,
  reducers: {
    updatePermission: (state, action: PayloadAction<PermissionInterface>) => {
      state.permission = action.payload;
    },
    updateOpenModalDeletePermission: (state, action: PayloadAction<boolean>) => {
      state.openModalDeletePermission = action.payload;
    },
    updateFormAction: (state, action: PayloadAction<FormAction>) => {
      state.formAction = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { updatePermission, updateOpenModalDeletePermission, updateFormAction } =
  permissionSlice.actions;

export default permissionSlice.reducer;
